import React, { useState } from 'react';
import { BoxStyled } from '../../estimatingRequirements/faisyEquation/style';
import { NavigationButtons } from '../../../shared/components/navigationButtons';
import { Box, Modal } from '@mui/material';
import { TextWithInfoIcon } from '../../../shared/components/textWithInfoIcon';
import { ArcContainer } from '../../../shared/components/arcContainer';
import { SingleNumberCard } from '../../../shared/components/numberInput/numberCards/singleNumberCard';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../store/hooks';
import { metaDataSelector } from '../../../store/globalSelectors';
import { setHGSSelection } from '../../../store/slices/metaDataSlice';
import { Tooltip } from '../../../shared/components/toolTip/';

import InfoIcon from '../../../assets/icons/infoIcon.svg';
import leftHandIcon from '../../../assets/icons/leftHandIcon.svg';

export const HandGripStrength = () => {
  const { muscleScreening } = useAppSelector(metaDataSelector);
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <>
      <BoxStyled>
        {/* Top Bar (title + info icon) */}
        <TextWithInfoIcon
          title={'HAND GRIP STRENGTH'}
          icon={InfoIcon}
          fontSize={'1.5rem'}
          lineHeight={'1.375rem'}
          variant={'h1'}
          handleIconClick={handleOpen}
        />
        <ArcContainer icon={leftHandIcon}>
          <Box sx={{ textAlign: 'center', mb: 2, mt: 5 }}>
            <Box
              sx={{
                border: '0.0625rem solid #D9D9D6',
                borderRadius: '0.9375rem',
                marginTop: '1.25rem'
              }}
              className="pt-16"
            >
              <SingleNumberCard
                data-testid={'test-HGS'}
                width={'100%'}
                title={'ENTER THE AVERAGE HANDGRIP STRENGTH OF YOUR PATIENT'}
                marginVal={'0.625rem'}
                range={{ min: 0, max: 250 }}
                subHead={'(kg)'}
                value={muscleScreening.handGripStrength}
                setValue={(val: number) =>
                  dispatch(
                    setHGSSelection({
                      ...muscleScreening,
                      handGripStrength: Number(val)
                    })
                  )
                }
              />
            </Box>
          </Box>
        </ArcContainer>
      </BoxStyled>

      <NavigationButtons
        nextDisabled={false}
        nextRoute={'/muscle-screening/handgrip-strength/screening-result'}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Tooltip
          onClose={handleClose}
          title={'Reference:'}
          content={
            'Cruz-Jentoft et al., 2019. Age and ageing, 48(1), 16–31 and Dodds RM et al. PLoS One. 2014;9(12):e113637'
          }
        />
      </Modal>
    </>
  );
};
